var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1276_37259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18549 5.81451C6.45398 5.54602 6.87535 5.52347 7.16934 5.74718L7.24618 5.81427L12.3737 10.94L17.5024 5.81133C17.7953 5.51845 18.2702 5.51845 18.563 5.81133C18.8315 6.07982 18.8539 6.50126 18.6302 6.7952L18.563 6.87199L13.4343 12.0007L18.5616 17.1252C18.8546 17.418 18.8548 17.893 18.5619 18.1858C18.2934 18.4543 17.8721 18.4769 17.578 18.2532L17.5012 18.1861L12.3737 13.0614L7.24784 18.1872C6.95495 18.4801 6.48007 18.4801 6.18718 18.1872C5.9187 17.9187 5.89632 17.4973 6.12003 17.2033L6.18718 17.1265L11.313 12.0007L6.18573 6.87514C5.89277 6.58232 5.8926 6.1074 6.18549 5.81451Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1276_37259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.8c90115e5f717257666978575f40c982.svg";
export { ForwardRef as ReactComponent };